import { Component, Input, OnInit } from '@angular/core';
import { authService } from '../../../services/auth.service';
import { imagesService } from '../../../services/image.service';
import { HttpEventType } from '@angular/common/http';
import { usersService } from '../../../services/users.service';
import { alert } from '../../../services/alert.service';
import { assessmentService } from '../../../services/assessment.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-profile-card',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.scss'],
  standalone: false,
})
export class ProfileCardComponent implements OnInit {

  @Input() user: any;
  @Input() totalCoins: number = 0;
  lock: boolean = false;

  isImageChange: boolean = false;
  orignalImage: File;
  imageUrl: string;

  userImage: string | undefined;
  inProcessing: boolean = false;
  totalAssess: number = 0
  isChange: boolean = false;
  isPause: boolean = false;
  expireDate = null
  pauseStatus = 'paused';
  constructor(
    private auth: authService,
    private imagesService: imagesService,
    private userService: usersService,
    private assessmentService: assessmentService,
    private router: Router,
    private alert: alert
  ) { }

  ngOnInit(): void {
    this.getUserAssessment();
    if(this.user){
      console.log('user' , this.user?.subscription)
      if(this.user?.subscription?.status == 'paused'){
        this.isPause = true;
        this.expireDate = this?.user?.subscription?.expire_at;
      } else {
        this.isPause = false;
        this.expireDate = null;
      }
    } else{
      console.log('user not available')
    }
  }

  getUserAssessment() {
    let userId = this.auth?.userAuthData?.user?.id
    if (!userId) {
      return
    }
    this.assessmentService.getUserGivenAssessments(userId).subscribe(res => {
      this.totalAssess = res.data.length
    })
  }

  isAllowEdit() {
    const { id, subscription } = this.user;
    if(subscription){
    const { package_reference } = subscription;
    if (id == this.auth?.userAuthData?.user?.id && package_reference != 'starter_tier') {
      return true
    } else {
      return false;
    }
    }
    return false;

  }


  isFreeUser(): boolean {

  if(!this.user?.subscription ||  this.user?.subscription?.package_reference === 'starter_tier'){
    return true;
  } else {
    return false
  }
}


  triggerFileInput(): void {
    document.getElementById('ImageInput').click();

  }

  onFrontFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      this.orignalImage = file;
      this.user.image_url = URL.createObjectURL(file);
    }
    input.value = ''
  }

  updateProfileImage() {
    this.inProcessing = true;
    this.uploadAndGetUrl(this.orignalImage).then(data => {
      this.user.image_url = data;
      if (!this.user.city) {
        this.user.city = ''
      }
      if (!this.user.state) {
        this.user.state = ''
      }
      this.userService.updateUserById(this.user.id, this.user).subscribe(res => {
        this.inProcessing = false;
        this.orignalImage = null;
        this.auth.userDetail.next(res.data);
        this.alert.responseAlert('Profile image updated', 'success');
        this.isImageChange = false;
      })
    })
  }


  private uploadAndGetUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!file) {
        console.error('No file provided');
        reject('No file provided');
        return;
      }

      const fileNameWithoutSpaces = file.name.replace(/\s+/g, '_');
      const renamedFileName = fileNameWithoutSpaces;
      const renamedFile = new File([file], renamedFileName, { type: file.type });

      this.imagesService.getImageUploadLink(renamedFile.name, renamedFile.type, 'profile-image').subscribe({
        next: (res) => {
          this.imagesService.uploadFileToS3(res.data.signedRequest, renamedFile).subscribe({
            next: (event) => {
              if (event.type === HttpEventType.UploadProgress) {
                const percentDone = Math.round(100 * event.loaded / event.total);

              } else if (event.type === HttpEventType.Response) {
                resolve(res.data.url);
              }
            },
            error: (error) => {
              console.error('Error while uploading file to S3.', error);
              reject(error);
            },
            complete: () => console.log('File upload to S3 complete')
          });
        },
        error: (error) => {
          console.error('Error getting signed URL.', error);
          reject(error);
        }
      });
    });
  }

    manageMemberShip() {
      this.router.navigate(['/user/billing']);
    }
}
